<template>
    <div class="notice-popup">
        <div class="modal-container vstack">
            <div class="w-100 ar-32 position-relative">
                <swiper
                    :modules="swiperModules"
                    :slides-per-view="1"
                    :space-between="0"
                    :loop="true"
                    :speed="600"                                   
                    :autoplay="{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }"
                    @swiper="onSwiper"
                    @realIndexChange="onSlideChange"
                    >
                    <swiper-slide v-for="banner in bannerList" :key="banner.idx" @click="$commonUtils.moveAppAlert('home', 0)">
                        <img :src="$commonUtils.getImageUrl('banners/' + banner.image)" class="w-100 ar-31 cursor-pointer" style="object-fit:cover;" :class="{ 'br-12': !$commonUtils.checkMobile() }"/>
                    </swiper-slide>
                </swiper>

                <div class="banner-slider-navigation">{{ banner_slider_idx + ' / ' + bannerList.length}}</div>
            </div>
            <div class="footer w-100 hstack">
                <button class="btn w-50 fs-14 fw-600" style="padding: 12px 0px;" @click="closeModal">하루 보지 않기</button>
                <button class="btn w-50 fs-14 fw-600" style="padding: 12px 0px;" @click="closeModal">닫기</button>
            </div>
        </div>
        
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { FreeMode, Scrollbar, Mousewheel, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';

export default {
    name: "NoticeModal",
    data() {
        return {
            swiperModules: [Autoplay, FreeMode, Scrollbar, Mousewheel],

            bannerList : [],
            banner_slider_idx : 1,
        }
    },
    methods: {
        closeModal() {
            this.$emit('update:showModal', false);
        },

        getBottomBanner() {
            const me = this;                      // ← this 캡처

            // 문자열로 붙여도 되지만, params를 쓰면 더 안전
            me.axios.get('banner/bottom', {
                params: {
                    state : "ON",
                },
            })
            .then(function (res) {
                if (res.status === 200) {

                    me.bannerList = res.data;
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
            });
        },

        onSwiper(swiper) {
            const idx = Number.isFinite(swiper?.realIndex)
            ? swiper.realIndex
            : (Number.isFinite(swiper?.activeIndex) ? swiper.activeIndex : 0);
            this.banner_slider_idx = idx + 1;
        },
        onSlideChange(swiper) {
            const idx = Number.isFinite(swiper?.realIndex)
            ? swiper.realIndex
            : (Number.isFinite(swiper?.activeIndex) ? swiper.activeIndex : 0);
            this.banner_slider_idx = idx + 1;
        },


    }    
}
</script>
<style scoped>
    @import "@/css/common.css";
    @import "@/css/style.css";

    .notice-popup {
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 30%;
        background-color: #fff;
        display: flex;
        z-index: 9998;
    }

    .modal-container {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        position: relative;
    }

</style>